import { ITaskChannel } from "./IExternalAgent";

interface IProps {
  taskChannels: Array<ITaskChannel>;
  onChange: (updatedChannels: Array<any>) => void;
}
const TaskChannels = ({ taskChannels, onChange }: IProps) => {
  return (
    <>
      Task Channels
        <hr />
      {taskChannels.map((channel: ITaskChannel, index: number) => {
        return (
          <div key={index}>
            <span>{channel.name}</span>
            <input
              type="number"
              value={channel.capacity}
              onChange={(e) => {
                const updatedChannels = [...taskChannels];
                updatedChannels[index].capacity = parseInt(e.target.value);
                onChange(updatedChannels);
              }}
            />
            <input
              type="checkbox"
              checked={channel.available}
              onChange={(e) => {
                const updatedChannels = [...taskChannels];
                updatedChannels[index].available = e.target.checked;
                onChange(updatedChannels);
              }}
            />
          </div>
        );
      })}
    </>
  );
};

export default TaskChannels;
